import { Link } from "gatsby"
import React from 'react'
//import HomePlaces from './home-places'
import MapboxPlaces from "./mapbox-places";

import Logo from '../../images/uhslogo-red.svg'

function LocationHeader() {
    
    return (
      <header className="sl_header">
        <div className="sl_header__search">
          <Link className="sl_logo" to="/search">
            <img alt="UHS Header Logo" src={Logo}></img>
          </Link>
          {/*<HomePlaces
          />*/}
            <span className="algolia-places">
                <MapboxPlaces />
            </span>
            <a className="sl_header__talkspace" href="https://www.talkspace.com/?utm_source=uhs-findbhhelp&utm_medium=referral" target="_blank" rel="noreferrer">
              <span className="sl_header__talkspace-icon"><i className="fas fa-laptop"></i><i className="fas fa-mobile-alt"></i></span>
              Virtual Therapy via Talkspace
            </a>
        </div>{/*end sl_header__search*/}
        <a className="sl_header__talkspace-banner" href="https://www.talkspace.com/?utm_source=uhs-findbhhelp&utm_medium=referral" target="_blank" rel="noreferrer">
          <span className="sl_header__talkspace-icon"><i className="fas fa-laptop"></i><i className="fas fa-mobile-alt"></i></span>
          Virtual Therapy via Talkspace
        </a>
    </header>
    )
};

export default LocationHeader